import * as translationTypes from "../types/translationTypes";

const initialState = {
  currentLanguage: "en",
};

const translationReducer = (state = initialState, action) => {
  switch (action.type) {
    case translationTypes.SET_CURRENT_LANGUAGE:
      return { ...state, currentLanguage: action.payload };
    default:
      return state;
  }
};

export default translationReducer;
